export const SWITCH_ENV_STEPS = {
  VIDEO: 'VIDEO',
  MIGRATE: 'MIGRATE',
  MIGRATE_AUTOMATIONS_ONLY: 'MIGRATE_AUTOMATIONS_ONLY',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
};
